module.exports = __webpack_public_path__ + "img/ideaBuddy-white.f190bfbd.svg";